const ru = {
  buyExam: "Купить Mock экзамен",
  makePayment: "Оплатить",
  candidateDetails: "Детали кандидата",
  fullName: "Полное имя",
  phoneNumber: "Номер телефона",
  email: "Электронная почта",
  fillDetails: "Пожалуйста, заполните данные ниже:",
  residenceCountry: "Страна проживания",
  Other: "Другое",
  Uzbekistan: "Узбекистан",
  passportNo: "Номер паспорта или ID (нп. AA1234567)",
  invalidPassportNo: "Пожалуйста, введите правильный номер паспорта или ID.",
  dob: "Дата рождения",
  wrongPassportOrDob:
    "Неправильный номер паспорта или дата рождения, проверьте",
  proceed: "ПРОДОЛЖИТЬ",
  firstName: "Имя (на паспорте)",
  lastName: "Фамилия (на паспорте)",
  disclaimer: "Предупреждение",
  disclaimerText:
    "Эти тест материалы для подготовки к тесту TKT являются неофициальными и не одобрены и не связаны с Cambridge English. Весь контент, включая вопросы, ответы и объяснения, был создан Edu-Action Exams Centre и является полностью уникальным. Предоставленные материалы предназначены только для практических целей и не копируют содержание официального экзамена TKT. Основная цель этих тестов – дать кандидатам возможность почувствовать атмосферу реального экзамена с ограничением по времени. Кандидатам следует обращаться к официальным ресурсам Cambridge English для получения достоверной информации.",
  processingFee: "Комиссия",
  totalPay: "Итого к оплате",
  price: "Цена",
  cardNo: "Номер карты",
  validThru: "Действительна до",
  phoneNo: "Номер телефона",
  enterCode: "Введите код из SMS",
  pay: "ОПЛАТА",
  securePaymentTitle: "Безопасная обработка платежей:",
  securePayment1:
    "Ваша безопасность - наш приоритет. Мы не храним данные вашей карты. Все платежи безопасно обрабатываются через",
  securePayment2:
    "доверенный сервис третьей стороны. Наслаждайтесь спокойствием с шифрованием end-to-end и проверкой OTP для дополнительной безопасности.",
  codeSent: "Код отправлен на ",
  paidSuccess: "Вы успешно оплатили Mock экзамен",
  moduleNA:
    "В данный момент нет доступных тестов на этот модуль. Пожалуйста, проверьте позже.",
  selectModule: "Выберите модуль",
  passportOrDobWrong: "Неправильный номер паспорта или дата рождения",
  testDetails: "Детали теста",
  finished: "Завершено",
  boughtOn: "Куплено на",
  takeTest: "Пройти тест",
  takeTest1: "Вы можете пройти тест",
  takeTest2: "здесь",
  changePassword: "Изменить пароль",
  logout: "Выйти",
  registerTitle: "Регистрация пробного теста",
  register: "Зарегистрироваться",
  password: "Пароль",
  passwordConfirm: "Подтвердите пароль",
  alreadyRegistered: "Уже зарегистрированы? Войти",
  smthWentWrong: "Что-то пошло не так, пожалуйста, попробуйте снова",
  enterCorrectPhone: "Пожалуйста, введите правильный номер телефона",
  passwordsNotMatch: "Пароли не совпадают",
  repeatPassword: "Повторите ваш пароль",
  atLeast6: "Значение должно быть не менее 6 символов",
  enterPassword: "Пожалуйста, введите ваш пароль",
  enterEmail: "Пожалуйста, введите ваш email",
  enterPhone: "Пожалуйста, введите ваш номер телефона",
  enterLastName: "Пожалуйста, введите вашу фамилию",
  enterFirstName: "Пожалуйста, введите ваше имя",
  loginText: "Пожалуйста, используйте ваши учетные данные для входа",
  login: "Войти",
  forgotPassword: "Забыли пароль",
  notRegistered: "Еще не зарегистрированы?",
  submit: "Отправить",
  checkYourEmail: "Пожалуйста, проверьте ваш email",
  forgotPasswordText:
    "Пожалуйста, используйте ваш зарегистрированный email для получения ссылки для сброса пароля.",
  enterNewPassword: "Пожалуйста, введите новый пароль",
  enterOldPassword: "Пожалуйста, введите старый пароль",
  passwordsShouldMatch: "Новый и подтвержденный пароли должны совпадать",
  resetPasswordText: "Пожалуйста, придумаете новый пароль.",
  resetPassword: "Сброс пароля",
  newPassword: "Новый пароль",
  oldPassword: "Старый пароль",
  changePasswordText:
    "Пожалуйста, используйте ваш старый пароль для установки нового пароля.",
  backHome: "Вернуться на главную",
  trainings: "Учебные видео",
  mockExams: "Пробные экзамены",
  training: "Обучение",
  videos: "видео",
  video: "Видео",
  playlist: "Плейлист",
  watch: "Смотреть",
};

export default ru;
